export class ReportFileTypesConstants {
  public static LOCAL_FILE_REPORT = 'Transfer Pricing Documentation';
  public static BENCHMARK_REPORT = 'Benchmark Report';
  public static MASTER_FILE_REPORT = 'Master File Report';
  public static ANALYSIS_BENCHMARK_REPORT = 'Analysis-Benchmark-Report';
}
